import { createContext, useContext } from "react";
import { tokens } from "./weet-tokens.js";
const defaultWeetTokens = tokens;
const WeetContext = /*#__PURE__*/ createContext({
    tokens: defaultWeetTokens
});
const WeetTokensProvider = WeetContext.Provider;
const useWeetTokens = ()=>{
    const context = useContext(WeetContext);
    if (!context) throw new Error("useWeetTokens \u5FC5\u987B\u5728 WeetProvider \u5185\u90E8\u4F7F\u7528");
    return context;
};
export { WeetTokensProvider, useWeetTokens };
